// extracted by mini-css-extract-plugin
export default {"CloseButton":"CloseButton-styles__CloseButton__VJA1J","CloseButton__icon":"CloseButton-styles__CloseButton__icon__biqBL"};